import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ContactView, QuickSearchContactsParameters } from '@app/services/http/clients/api-proxies';
import { ContactService } from '@app/services/http/clients/contact.service';
import { GenericTypeAheadDropdownComponent, GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { ITypeAheadService } from '../../generic-type-ahead/generic-type-ahead.component';
import { createValueAccessorProvider, FormEditorBase } from '../base/form-editor-base';

@Component({
    selector: 'app-company-main-contact-form-editor',
    templateUrl: './company-main-contact-form-editor.component.html',
    styleUrl: './company-main-contact-form-editor.component.scss',
    providers: [createValueAccessorProvider(CompanyMainContactFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadDropdownComponent, GenericTypeAheadMultiselectComponent]
})
export class CompanyMainContactFormEditorComponent extends FormEditorBase<ContactView[]> implements OnInit {
    // Inputs for direct signal usage
    value = input<ContactView[]>();
    readonly = input<boolean>();
    placeholderText = input<string>('Select Main Contact');
    multiple = input<boolean>(true);
    labelText = input<string>('Main Contact');

    private readonly contactService: ITypeAheadService<ContactView, QuickSearchContactsParameters> =
        inject(ContactService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadContacts();
    }

    selectedItem(): ContactView | undefined {
        const items = this.selectedItems();
        return items && items.length > 0 ? items[0] : undefined;
    }

    onSelectedItemChange(selectedItem?: ContactView): void {
        if (selectedItem && selectedItem !== null) {
            this.selectedItems.set([selectedItem]);
        } else {
            this.selectedItems.set([]);
        }
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text) {
            this.items.set([]);
            return;
        }

        const contacts = await this.contactService.search({
            filterText: text,
            onlyMain: true
        } as QuickSearchContactsParameters);

        if (contacts) {
            this.items.set(contacts);
        }
    }

    protected override mapSelectedItemsToValue(): ContactView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: ContactView[]): any[] {
        return value || [];
    }

    private async loadContacts(): Promise<void> {
        this.items.set([]);
    }
}
